export { default } from './ParentModelCard';
